module.exports = __webpack_public_path__ + "static/basic-flow_6-50a4ee945e05c936985fa43108ac857f.png";